import { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import * as authService from '@/services/authService';
import useAuthStore from '@/store/authStore';

export default function AuthBootstrap({ children }) {
  const token = useAuthStore((state) => state.token);
  const refreshSession = useAuthStore((state) => state.refreshSession);
  const logout = useAuthStore((state) => state.logout);
  const navigate = useNavigate();
  const [isBootstrapping, setIsBootstrapping] = useState(true);
  const bootstrappedToken = useRef(null);

  useEffect(() => {
    let active = true;
    const tokenKey = token || 'anonymous';

    if (bootstrappedToken.current === tokenKey) {
      setIsBootstrapping(false);
      return () => {
        active = false;
      };
    }

    bootstrappedToken.current = tokenKey;

    authService.getMe()
      .then((res) => {
        if (!active) return;
        const { user, player } = res.data.data;
        refreshSession(user, player);
      })
      .catch((err) => {
        // Only logout on explicit 401 — network errors keep the session alive
        if (active && err?.response?.status === 401) {
          const role = useAuthStore.getState().user?.role;
          logout();
          navigate(role === 'partner' ? '/logista/login' : '/login', { replace: true });
        }
      })
      .finally(() => {
        if (active) setIsBootstrapping(false);
      });

    return () => {
      active = false;
    };
  }, [token, refreshSession, logout]);

  if (isBootstrapping) {
    return <div className="h-full w-full bg-pirate-dark" />;
  }

  return children || <Outlet />;
}
